import { FolderFileQuery } from "src/core/gql/graphql";
import { FolderEntrepriseFormValues } from "src/core/types/folder";
import { DocumentField } from "src/core/utils/documents";

/**
 * Formate une date au format YYYY-MM-DD pour les champs de type date HTML
 */
const formatDateForInput = (dateString: string | null | undefined): string | undefined => {
  if (!dateString) return undefined;

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return undefined;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch {
    return undefined;
  }
};

export const getDefaultDocuments = (
  folderFile: FolderFileQuery,
  corporationId: string,
  requiredDocuments: DocumentField[]
) => {
  return requiredDocuments.reduce(
    (acc, doc) => {
      const existingDoc = folderFile?.folderFile?.fileCustomerFolder?.stakeholders
        ?.find((s: { entity: { id: string } }) => s.entity.id === corporationId)
        ?.supportingDocuments?.find((d) => d.mainDocument?.type?.code === doc.code);

      const rawExpirationDate =
        existingDoc?.mainDocument?.__typename === "Document"
          ? existingDoc?.mainDocument?.expirationDate ?? undefined
          : undefined;

      acc[doc.code] = {
        file: null,
        existing:
          existingDoc?.mainDocument?.__typename === "ExternalDocument" &&
          existingDoc.mainDocument.id !== undefined,
        fileId: existingDoc?.mainDocument?.id ?? undefined,
        fileName:
          existingDoc?.mainDocument?.__typename === "Document"
            ? existingDoc?.mainDocument?.name ?? undefined
            : undefined,
        expirationDate: formatDateForInput(rawExpirationDate),
      };

      return acc;
    },
    {} as FolderEntrepriseFormValues["documents"]
  );
};
